import { CurrentVersion } from '../interfaces/Organization';
import { MEvaluationCreator } from './evaluation-creator.model';
import { MActiveSubversion } from './active-subversion.model';
import { MVersionEvaluation } from './version-evaluation.model';

export class MCurrentVersion{
  public active: boolean;
  public id: number;
  public version: string;
  public currentEvaluation: MVersionEvaluation = null;
  public oldEvaluation: MVersionEvaluation = null;
  public activeEvaluation: boolean = false;
  public subversion: MActiveSubversion = null;

  constructor(version: CurrentVersion){
    this.active = version.activo;
    this.id = version.id;
    this.version = version.version;
    this.activeEvaluation = version.existe_evaluacion;
    if (version.subversion_activa) {
      this.subversion = new MActiveSubversion(version.subversion_activa);
    }
    if (version.evaluacion) {
      this.currentEvaluation = new MVersionEvaluation(version.evaluacion)
    } 
    if (version.evaluacion_anterior) {
      this.oldEvaluation = new MVersionEvaluation(version.evaluacion_anterior)
    }
  }
}
